import AppModal from "components/Modal";
// import { loginKeychain } from "helpers/keychain";
// import { loginWithWif } from "helpers/steem";
import React, { useState }  from 'react';
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
// import { useForm } from "react-hook-form"; 

import {
//   Button,
  Card,
  CardBody,
//   FormGroup,
//   Form, 
//   InputGroupText,
//   InputGroup,
//   Label,
  Alert
} from "reactstrap"; 
 

type Props = {
    community:any,
    isShowing: boolean,
    hide: any
}
const nl2br = text =>
    text.split('\n').map((item, key) => (
        <span key={key}>
            {item}
            <br />
        </span>
    ));

function teamMembers(members) {
    return members.map((row) => {
        const account = `${row[0]}`;
        const title = row[2];
        const role = row[1];
        if (role === 'owner') {
            return null;
        }
        return (
            <div
                className="mb-2"
                key={`${account}__${role}`}
                style={{ fontSize: '80%' }}
            >
                <Link to={`/u/${account}`} className="link">@{account}</Link>
                {role && <span className="user_role"> {role} </span>}
                {title && <span className="community-label">{title}</span>}
            </div>
        );
    });
}
export const CommunityInfoModal = ({ community, isShowing, hide }: Props) => {
//   const { register, handleSubmit } = useForm<FormData>();  
  const [errorMessage, setErrorMessage] = useState<string | null>(null); 

  if (!community) {
    setErrorMessage("No community selected");
  }

  const renderForm = (
    <div className="modal-body p-0">
      <Card className="body-gray shadow border-0">
        <CardBody className="px-lg-5 py-lg-5">
          {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
          {community.flag_text && (
            <>
                <div className="text-center text-muted mb-2">
                    <small><b>Rules:</b></small> 
                </div>
                <p style={{textAlign:"left"}}>{nl2br(community.flag_text)}</p>
            </>
          )}
          {community.description && (
            <>
                <div className="text-center text-muted mb-2">
                    <small><b>Description:</b></small> 
                </div>
                <p style={{textAlign:"left"}}>{nl2br(community.description)}</p>
            </>
          )}
          {community.team && (
            <>
                <div className="text-center text-muted mb-2">
                    <small><b>Team:</b></small> 
                </div>
                {teamMembers(community.team)}
            </>
          )}
          
        </CardBody>
      </Card>
    </div>
  );

  return (
    isShowing ? ReactDOM.createPortal(
      <React.Fragment>
        <AppModal
          isShowing={isShowing}
          hide={hide}
          size="md"
          header={`Details for ${community.title} (${community.name}):`}
          children={renderForm}
        />
      </React.Fragment>, document.body
    ) : null)
};

export default CommunityInfoModal;